import { render, staticRenderFns } from "./ViewStone.vue?vue&type=template&id=335d3ac8&"
import script from "./ViewStone.vue?vue&type=script&lang=js&"
export * from "./ViewStone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports